var $ = require('jquery');
var NotificationBase = require('../NotificationBase');
/**
 *
 */
(function() {

    var MaintenanceModeNotification = NotificationBase.extend({
        /**
         * Default sticky for MaintenanceModeNotification
         */
        stickyDefault: 1,
        /**
         * Default severity for MaintenanceModeNotification
         */
        severityDefault: 3,
        /**
         * Default category for MaintenanceModeNotification
         */
        categoryDefault: 1,
        /**
         * parameters for determining default operation,
         * if null or false, they are ignored
         */
        iconCls: 'ui-icon-settings',
        /**
         * this method must be implemented by all Notifications
         */
        getContent: function() {
            var messages = {
                offline: {
                    heading: '',
                    description: ''
                }
            };
            // get translations //
            this.messages = $.extend(true, {}, this.messages, jimdoData.messages.toolbar.maintenance); // note: we break object reference

            var title, description;

            title = this.messages['offline'].notification.title;
            description = this.messages['offline'].notification.description;

            var elementHtml =
                '<div class="title">' + title + '</div>' +
                '<div class="description">' + description + '</div>' +
                '<a href="javascript:;">' + this.messages.link + '</a>';

            return elementHtml;
        },

        globalAction: function() {
            diy.editor.deeplinking.requestPath([
                {label: 'siteadmin', params: 'settings'},
                {label: 'SAC.Settings', params: 'website-staging'}
            ]);
        },

        getName: function() {
            return 'MaintenanceModeNotification';
        }
    });

    module.exports = MaintenanceModeNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/MaintenanceModeNotification.js
 ** module id = 652
 ** module chunks = 0
 **/